import {
    fetchAllTripsAction,
} from 'wanderu-ducks-psearch';

import {
    selectors as searchSelectors,
} from '../../appstate/search';

function reset(searchParams) {
    return (dispatch, getState) => {
        const psearchParams = searchSelectors.selectPSearchParams(getState(), searchParams);
        dispatch(fetchAllTripsAction.reset(psearchParams));
    };
}

export {
    reset,
};
